module.exports = __webpack_public_path__ + "img/active-logout.36606be3.svg";